module.exports = __webpack_public_path__ + "img/ic_hunzhuang.67dd2e4e.png";